
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class SlidePop extends Vue {
  @Prop() show: boolean
  @Prop({ default: '' }) title: string
  @Prop({ default: 0 }) slide: number
  @Prop({ default: true }) showFooter: boolean
  @Prop({ default: false }) footerSlot: boolean
  @Prop({ default: '确认' }) confirmText: string
  @Prop({ default: 25 }) paddingX: number
  @Prop({ default: true }) autoHeight: boolean

  slide2Height = 0

  @Watch('show')
  handleShow(isShow) {
    if (isShow) {
      this.$nextTick(() => {
        const el = document.querySelector('.slide-1.show')
        if (el) {
          this.slide2Height = el.getBoundingClientRect().height
        }
      })
    }
  }
}
